import React from 'react'
import PriceUtil from 'utils/price-util'
import { Badge, Button } from 'reactstrap'
import PropTypes from 'prop-types'

const propTypes = {
  buttonText        : PropTypes.string,
  buttonColour      : PropTypes.string,
  onButtonClick     : PropTypes.func,
  isButtonDisabled  : PropTypes.bool,
  cartItems         : PropTypes.array,
  selectedCartItems : PropTypes.array,
  toggleAllCheckbox : PropTypes.func,
  toggleCheckbox    : PropTypes.func
}

/**
 * Merchant Inbound Item Reject Table Columns
 */
const CustomerCheckoutTableColumns = ({
  buttonText,
  buttonColour,
  onButtonClick,
  isButtonDisabled,
  cartItems,
  selectedCartItems,
  toggleAllCheckbox,
  toggleCheckbox
}) => {
  // Custom Cell
  // Used to modify the cell in specific columns
  const ImageCell      = (row) => <img style={{ width: '8rem' }} src={ row.cell.value } alt={ row.row.original.name }/>
  const CheckboxHeader = () => {
    const checked = selectedCartItems.length === cartItems.length

    return (
      <input
        id={ 'customer-cart-item-toggle-all-checkbox' }
        type='checkbox'
        checked={ checked }
        onChange={ toggleAllCheckbox }
        style={{ cursor: 'pointer' }}
      />
    )
  }
  const CheckboxCell = (row) => {
    const currentId       = row.cell.value
    const currentCartItem = row.row.original
    const checked         = selectedCartItems.some((item) => item.id === currentCartItem.id)

    return (
      <div className='text-center'>
        <input
          id={ `customer-cart-item-checkbox-${currentId}` }
          type='checkbox'
          checked={ checked }
          onChange={ () => toggleCheckbox(checked, currentCartItem) }
          style={{ cursor: 'pointer' }}
        />
      </div>
    )
  }
  const PriceCell = (row) => PriceUtil.format(row.cell.value)

  const StatusCell = (row) => {
    let value = row.cell.value
    return (
      <Badge color={ value === 'enabled' ?  'success' : 'danger' }>{ value }</Badge>
    )
  }

  // eslint-disable-next-line react/prop-types
  const ActionCell = ({ cell: { row } }) => {

    // eslint-disable-next-line react/prop-types
    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <Button
        color={ buttonColour }
        // eslint-disable-next-line react/prop-types
        onClick={ () => onButtonClick([ row.id ]) }
        size='sm'
        disabled={ disabled }
      >
        { buttonText }
      </Button>
    )

  }

  return (
    [
      {
        Header  : 'Customer Cart',
        columns : [
          {
            Header         : CheckboxHeader,
            accessor       : 'id',
            disableFilters : true,
            Cell           : CheckboxCell
          },
          {
            Header         : '',
            accessor       : 'product.image',
            disableFilters : true,
            Cell           : ImageCell
          },
          {
            Header         : 'Name',
            accessor       : 'product.name',
            disableFilters : true
          },
          {
            Header         : 'SKU',
            accessor       : 'product.sku',
            disableFilters : true
          },
          {
            Header         : <>Product <br/>Quantity</>,
            accessor       : 'product.quantity',
            disableFilters : true
          },
          {
            Header         : 'Status',
            accessor       : 'product.status',
            disableFilters : true,
            Cell           : StatusCell
          },
          {
            Header         : 'Size',
            accessor       : 'product_dimension.size',
            disableFilters : true
          },
          {
            Header         : 'Price',
            accessor       : 'product.price',
            disableFilters : true,
            Cell           : PriceCell
          },
          {
            Header         : <>Quantity <br/>Added</>,
            accessor       : 'quantity',
            disableFilters : true
          },
          {
            Header : 'Action',
            id     : 'action',
            Cell   : ActionCell
          }
        ]
      }
    ]
  )
}

CustomerCheckoutTableColumns.propTypes = propTypes

export default CustomerCheckoutTableColumns